import { ErrorMessage, Select, Spinner } from '@forge/react';
import React, { useEffect, useState } from 'react';
import { useFieldOptions } from '../../libs/useFieldOptions';
export function SelectResource(props) {
    const [resource, setResource] = useState();
    const { selectOptions, isLoadingFields } = useFieldOptions(props.config);
    useEffect(() => {
        if (selectOptions.length) {
            if (props.value) {
                const value = selectOptions.find((v) => v.value === props.value);
                if (value) {
                    setResource(value);
                }
            }
        }
    }, [selectOptions, props.value]);
    if (isLoadingFields) {
        return React.createElement(Spinner, null);
    }
    if (selectOptions.length === 0) {
        return React.createElement(ErrorMessage, null, "No available options, check Booking Flow configuration.");
    }
    if (props.config.resourceSource !== 'customfield' || selectOptions.length === 0) {
        return null;
    }
    const { onChange, isRequired } = props;
    return React.createElement(Select, { id: 'resource', value: resource, onChange: onChange, isRequired: isRequired, options: selectOptions });
}
